import styled from 'styled-components';

export const PriceTable = () => {
  return (
    <Table>
      <Thead>
        <Tr>
          <Th>
            <ColName>집 크기</ColName>
          </Th>
          <Th>
            <ColName>1회청소</ColName>
          </Th>
          <Th>
            <ColName>정기청소</ColName>
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td>19평 이하 (3시간 30분)</Td>
          <Td>
            <Price>52,300원~</Price>
          </Td>
          <Td>
            <Price>51,100원~</Price>
          </Td>
        </Tr>
        <Tr>
          <Td>20평~34평 (4시간)</Td>
          <Td>
            <Price>59,800원~</Price>
          </Td>
          <Td>
            <Price>58,400원~</Price>
          </Td>
        </Tr>
        <Tr>
          <Td>35평~44평 (4시간 30분)</Td>
          <Td>
            <Price>67,200원~</Price>
          </Td>
          <Td>
            <Price>65,700원~</Price>
          </Td>
        </Tr>
        <Tr>
          <Td>45평 이상 (5시간)</Td>
          <Td>
            <Price>74,700원~</Price>
          </Td>
          <Td>
            <Price>73,000원~</Price>
          </Td>
        </Tr>
      </Tbody>
    </Table>
  );
};

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  & thead tr th {
    border-bottom: 1px solid #0c8ea7;
  }

  & tbody tr:not(:last-child) td {
    border-bottom: 1px solid #0c8ea7;
  }
`;

const Thead = styled.thead``;

const Th = styled.th`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 140%;
  color: #126876;
  text-align: left;
  padding-bottom: 12px;
  word-break: keep-all;

  &:nth-child(2) {
    width: 364px;
  }

  &:last-child {
    width: 130px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 14px;
    padding-bottom: 12px;

    &:nth-child(2) {
      width: 264px;
    }

    &:last-child {
      width: 100px;
    }
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 12px;
    padding-right: 8px;
    font-weight: 600;

    &:last-child {
      width: 85px;
    }
  }

  @media (max-width: 428px) {
    &:last-child {
      width: 100px;
    }
  }
`;

const ColName = styled.span`
  display: inline-block;
  word-break: keep-all;
  width: 80%;

  @media (max-width: 428px) {
    max-width: 200px;
  }
`;

const Tbody = styled.tbody``;

const Tr = styled.tr`
  position: relative;
  /* 
  thead &::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 1px;
    background-color: #0c8ea7;
  }

  tbody &:nth-child(n + 1)::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: calc(50% + 20px);
    height: 1px;
    background-color: #26a2b5;

    @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
      width: calc(50% + 28px);
    }
  }

  tbody &:last-child::after {
    display: none;
  }

  tbody &:nth-child(2n)::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #0c8ea7;
  } */
`;

const Td = styled.td`
  font-weight: 600;
  font-size: 24px;
  line-height: 140%;
  color: #ffffff;
  white-space: nowrap;

  padding-top: 24px;
  padding-bottom: 32px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding-top: 17px;
    padding-bottom: 18px;
    font-size: 18px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding-top: 21px;
    padding-bottom: 19px;
    font-size: 16px;
    font-weight: 400;

    tbody tr &:first-child {
      font-weight: 600;
    }
  }
`;

const Price = styled.span`
  font-weight: 700;
  font-size: 26px;
  line-height: 140%;
  color: #ffffff;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 20px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 17px;
  }
`;
